import React, { useState, useEffect } from "react";
import {
  useNavigate,
  useParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { toast } from "react-hot-toast";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { State, City } from "country-state-city";
// My components
import SecCard from "../../components/common/SecCard";
import BackButton from "../../components/common/BackButton";
// My css
import instiCss from "../../css/institute/add-insti-page.module.css";
import { SERVER_ORIGIN, validation } from "../../utilities/constants";
import { useUserType } from "../../routes/common/UserTypeContext";
import {
  getDashboardPath,
  isPhoneNumberValid,
  getManageStudentsPath,
} from "../../utilities/helper_functions";
import axios from "axios";

const Userinsti = (props) => {
  const { _id } = useParams();
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const emIdFromUrl = searchParams.get("em_id");
  const [activeTab, setActiveTab] = useState(tabFromUrl || "institute");
  const [instiForm, setinstiForm] = useState({
    name: "",
    officerName: "",
    officerEmail: "",
    officerNumber: "",
    country: "India",
    designation: "",
    state: "",
    city: "",
    createdBy: emIdFromUrl || _id || sessionStorage.getItem("_id") || "",
    type: "institute", // Add type field to distinguish between institute and thalir
    // privacyAcknowledged: false,
  });
  const [errors, setErrors] = useState({});

  // Reset form when switching tabs
  useEffect(() => {
    setinstiForm({
      name: "",
      officerName: "",
      officerEmail: "",
      officerNumber: "",
      country: "India",
      designation: "",
      state: "",
      city: "",
      createdBy: emIdFromUrl || _id || sessionStorage.getItem("_id") || "",
      type: activeTab,
      // privacyAcknowledged: false,
    });
    setSelectedState(null);
    setSelectedCity(null);
    setSelectedOption(null);
    setCities([]);
  }, [activeTab, _id, emIdFromUrl]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setinstiForm({ ...instiForm, [name]: value });
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isEdit = queryParams.get("edit") === "true";
  // const { id: userId } = useParams();
  const userId = queryParams.get("id"); // ✅ Get id from query params

  const onSubmit = (e) => {
    // e.preventDefault();

    // Check for empty fields
    const emptyFields = {};
    let missingFields = [];
    for (const field in instiForm) {
      if (!instiForm[field]) {
        if (field.includes("create") || field === "type") {
          continue;
        }
        missingFields.push(field);
        // emptyFields[field] = toast.error(`${field} is missing`);
      }
    }

    // Validate phone number format
    if (
      instiForm.officerNumber &&
      !isPhoneNumberValid(instiForm.officerNumber)
    ) {
      toast.error("Coordinator Number must be exactly 10 digits");
      return;
    }

    if (missingFields.length > 0) {
      missingFields = missingFields.join(", ");
      toast.error(`Please fill in all the required fields: ${missingFields}`);
    }
    if (Object.keys(emptyFields).length > 0) {
      setErrors(emptyFields);
      // console.log(emptyFields);
      return; // Stop form submission if there are empty fields
    }

    // Continue with form submission if all fields are filled
    // Submit logic goes here
  };

  const navigate = useNavigate();

  const [isinstitering, setIsinstitering] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  useEffect(() => {
    const indianStates = State.getStatesOfCountry("IN");
    setStates(
      indianStates.map((state) => ({ label: state.name, value: state.isoCode }))
    );
  }, []);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
    const stateCities = City.getCitiesOfState("IN", selectedOption.value);
    setCities(
      stateCities.map((city) => ({ label: city.name, value: city.name }))
    );
    setSelectedCity(null);
    setinstiForm((prevForm) => ({
      ...prevForm,
      state: selectedOption.label,
      city: "",
    }));
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
    setinstiForm((prevForm) => ({ ...prevForm, city: selectedOption.label }));
  };

  useEffect(() => {
    if (isEdit && userId && states.length > 0) {
      fetchStudentData();
    }
  }, [isEdit, userId, states]);

  const fetchStudentData = async () => {
    try {
      const res = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/users/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            //Authorization: `Basic ${basicAuth}`,
            "auth-token": sessionStorage.getItem("token"),
          },
        }
      );
      const data = await res.json();
      console.log("data:", data);
      if (res.ok) {
        setinstiForm(data?.user);
        // ✅ Set selectedOption for AsyncSelect
        setSelectedOption({
          value: data?.user?.createdBy,
          state: data?.user?.state,
          city: data?.user?.city,
        });

        // ✅ Also set selectedState and selectedCity
        const stateOption = states.find(
          (state) => state.label === data?.user?.state
        );
        if (stateOption) {
          setSelectedState(stateOption);
          const stateCities = City.getCitiesOfState("IN", stateOption.value);
          setCities(
            stateCities.map((city) => ({ label: city.name, value: city.name }))
          );
          setSelectedCity({ label: data?.user?.city, value: data?.user?.city });
        }
      } else {
        toast.error(data.statusText || "Failed to fetch student data");
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleinstiterClick = async () => {
    // todo: trim fields, validate
    try {
      // if (instiForm.privacyAcknowledged !== true) {
      //   toast.error("Please accept the privacy acknowledgement to continue");
      //   return;
      // }
      setIsinstitering(true);
      setIsBtnDisabled(true);
      const userId = "utkarsh@troology.in";
      const userPassword = "Redhood@23";
      const basicAuth = btoa(`${userId}:${userPassword}`);

      // Add isThalir: true only for Thalir data
      const formDataWithType = {
        ...instiForm,
        ...(activeTab === "thalir" && { isThalir: true }),
      };

      const response = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            //Authorization: `Basic ${basicAuth}`,
            "auth-token": sessionStorage.getItem("token"),
            //Authorization: `Basic ${basicAuth}`,
          },
          body: JSON.stringify(formDataWithType),
        }
      );

      const result = await response.json();
      // (response);
      // (result);

      setIsinstitering(false);
      setIsBtnDisabled(false);

      if (response.status >= 400 && response.status < 600) {
        if (response.status === 500) {
          toast.error(result.statusText);
        } else if (response.status === 409) {
          toast.error(result.statusText);
        } else if (response.status === 400) {
          // <-- handle validation errors
          toast.error(result.statusText);
        }
        setIsBtnDisabled(false);
        setIsinstitering(false);
      } else if (response.ok && response.status === 200) {
        toast.success(result.statusText); // institered therefore insti btn remains disabled
        // Redirect based on user type
        const userType = sessionStorage.getItem("userType");

        console.log("user Type::", userType);
        if (userType === "em") {
          navigate(-1);
          // navigate(`/em/institute/all?refresh=${Date.now()}&`);
        } else {
          navigate(-1);

          // navigate(`/institutes/all?tab=${activeTab}`);
        }
      } else {
        // for future
        setIsBtnDisabled(false);
      }
    } catch (err) {
      // (err.message);
      setIsBtnDisabled(false); // can reclick on institer btn
      setIsinstitering(false);
    }
  };

  const handleUpdateClick = async () => {

    const response = await fetch(
      `${SERVER_ORIGIN}/api/institute/auth/update-user/${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        },
        body: JSON.stringify(instiForm),
      }
    );
    const result = await response.json();
    if (result.userDoc) {
      toast.success(`College updated successfully`);
      navigate(-1);
    } else {
      toast.error("Some error occurred, please try again later");
    }
  };

  const [selectedOption, setSelectedOption] = useState(null);
  const [defaultOptions, setDefaultOptions] = useState([]);

  const loadOptions = async (inputValue, callback) => {
    try {
      const params = {
        search: inputValue,
        page: 1,
        limit: 10,
        sortBy: "name",
        sortType: "asc",
      };

      // Conditionally add the id parameter if we have an EM ID
      const emId = emIdFromUrl || _id;
      if (emId && emId !== "no_id") {
        params.id = emId;
      }
      const response = await axios.get(`${SERVER_ORIGIN}/api/em/auth/em/all`, {
        params,
      });
      const options = response.data.filteredInstitutes.map((em) => ({
        label: em.name,
        value: em._id,
        state: em.state,
        city: em.city,
      }));
      callback(options);
    } catch (error) {
      console.error("Error fetching institutes", error);
    }
  };

  useEffect(() => {
    const fetchDefaultOptions = async () => {
      try {
        const emId = emIdFromUrl || _id;
        const response = await axios.get(
          `${SERVER_ORIGIN}/api/em/auth/em/all`,
          {
            params: {
              search: "",
              page: 1,
              limit: 5,
              sortBy: "name",
              sortType: "asc",
              ...(emId ? { id: emId } : {}),
            },
          }
        );

        const options = response.data.filteredInstitutes.map((em) => ({
          label: em.name,
          value: em._id,
          state: em.state,
          city: em.city,
        }));

        setDefaultOptions(options);

        // ✅ only auto-select if EM exists AND states are already loaded
        if (emId && options.length > 0 && states.length > 0) {
          // const selected = options.find((em) => em.value === emId) || options[0];
          const selected = options.find((em) => em.value === emId);
          if (!selected) return;   // don't auto pick wrong EM

          setSelectedOption(selected);

          // ✅ update form
          setinstiForm((prevForm) => ({
            ...prevForm,
            createdBy: selected.value,
            state: selected.state || "",
            city: selected.city || "",
          }));

          // ✅ auto-select State dropdown
          const stateOption = states.find((s) => s.label === selected.state);
          if (stateOption) {
            setSelectedState(stateOption);

            const stateCities = City.getCitiesOfState("IN", stateOption.value);
            setCities(
              stateCities.map((city) => ({
                label: city.name,
                value: city.name,
              }))
            );

            setSelectedCity({
              label: selected.city,
              value: selected.city,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching default options", error);
      }
    };

    fetchDefaultOptions();
  }, [_id, emIdFromUrl, states]); // ✅ added states here

  const isNonInstitute = activeTab !== "institute";
  const isClusterMOU = instiForm.moutype === "Cluster MOU";

  const nameLabel =
    isNonInstitute && isClusterMOU ? "Nodal Officer Name" : "Coordinator Name";

  const emailLabel =
    isNonInstitute && isClusterMOU ? "Nodal Officer Email" : "Coordinator Email";

  const mobileLabel =
    isNonInstitute && isClusterMOU
      ? "Nodal Officer Mobile Number"
      : "Coordinator Number (10 digits)";
  const designation =
    isNonInstitute && isClusterMOU
      ? "Nodal Designation"
      : "Coordinator Designation";

  const renderForm = () => {
    const entityName = activeTab === "institute" ? "College" : "School";
    const entityNameLower = activeTab === "institute" ? "college" : "school";

    return (
      <div className="text-ff2" autoComplete="on">
        <div style={{ marginBottom: "0.8rem" }}>
          <label className={instiCss.instiLabel} htmlFor="name">
            {entityName} Name <span style={{ color: "red" }}>*</span>{" "}
          </label>
          <input
            className={instiCss.instiInput}
            type="text"
            id="name"
            name="name"
            placeholder={`Enter ${entityName} Name`}
            autoComplete="on"
            value={instiForm.name}
            onChange={onChange}
            maxLength={100}
          />
        </div>
        {activeTab !== "institute" && (
          <div style={{ marginBottom: "0.8rem" }}>
            <label className={instiCss.instiLabel} htmlFor="moutype">
              MOU Type <span style={{ color: "red" }}>*</span>
            </label>
            <select
              id="moutype"
              name="moutype"
              className={instiCss.instiInput}
              value={instiForm.moutype}
              onChange={onChange}
              required
            >
              <option value="">Select MOU Type</option>
              <option value="Single MOU">Single MOU</option>
              <option value="Cluster MOU">Cluster MOU</option>
            </select>
          </div>
        )}
        <div style={{ marginBottom: "0.8rem" }}>
          <label className={instiCss.instiLabel} htmlFor="officerEmail">
            {/* Coordinator Email <span style={{ color: "red" }}>*</span> */}
            {emailLabel} <span style={{ color: "red" }}>*</span>
          </label>
          <input
            className={instiCss.instiInput}
            type="email"
            id="officerEmail"
            name="officerEmail"
            placeholder="Enter Coordinator Email"
            value={instiForm.officerEmail}
            onChange={onChange}
            autoComplete="on"
            disabled={isEdit}
          />
        </div>

        <div style={{ marginBottom: "0.8rem" }}>
          <label className={instiCss.instiLabel} htmlFor="officerName">
            {/* Coordinator Name <span style={{ color: "red" }}>*</span> */}
            {nameLabel} <span style={{ color: "red" }}>*</span>

          </label>
          <input
            className={instiCss.instiInput}
            type="text"
            id="officerName"
            name="officerName"
            placeholder="Enter Coordinator Name"
            autoComplete="on"
            value={instiForm.officerName}
            onChange={onChange}
          />
        </div>


        <div style={{ marginBottom: "0.8rem" }}>
          <label className={instiCss.instiLabel} htmlFor="officerNumber">
            {/* Coordinator Number (10 digits) */}
            {mobileLabel} <span style={{ color: "red" }}>*</span>

            {/* <span style={{ color: "red" }}>*</span>{" "} */}
          </label>
          <input
            className={instiCss.instiInput}
            type="text"
            id="officerNumber"
            name="officerNumber"
            placeholder="Enter 10-digit mobile number"
            autoComplete="on"
            maxLength={10}
            pattern="[0-9]{10}"
            value={instiForm.officerNumber}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");
              if (value.length <= 10) {
                onChange({ target: { name: "officerNumber", value } });
              }
            }}
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </div>
        <div style={{ marginBottom: "0.8rem" }}>
          <label className={instiCss.instiLabel} htmlFor="designation">
            {designation} <span style={{ color: "red" }}>*</span>

            {/* Coordinator Designation <span style={{ color: "red" }}>*</span>{" "} */}
          </label>
          <input
            className={instiCss.instiInput}
            type="text"
            id="designation"
            name="designation"
            placeholder="Enter Coordinator Designation"
            autoComplete="on"
            value={instiForm.designation}
            onChange={onChange}
            minLength={8}
          />
        </div>
        <div style={{ marginBottom: "0.8rem" }}>
          <label className={instiCss.instiLabel} htmlFor="createdBy">
            Chapter EM Name <span style={{ color: "red" }}>*</span>
          </label>

          <AsyncSelect
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions={defaultOptions}
            // onChange={(selectedOption) => {
            //   if (selectedOption) {
            //     setinstiForm((prevForm) => ({
            //       ...prevForm,
            //       createdBy: selectedOption.value,
            //     }));
            //     setSelectedOption(selectedOption);
            //   }
            // }}
            onChange={(selectedOption) => {
              if (selectedOption) {
                setSelectedOption(selectedOption);

                setinstiForm((prevForm) => ({
                  ...prevForm,
                  createdBy: selectedOption.value,
                  state: selectedOption.state || "",
                  city: selectedOption.city || "",
                }));

                // ✅ auto-fill state & city when user selects EM manually
                const stateOption = states.find((s) => s.label === selectedOption.state);
                if (stateOption) {
                  setSelectedState(stateOption);

                  const stateCities = City.getCitiesOfState("IN", stateOption.value);
                  setCities(
                    stateCities.map((city) => ({
                      label: city.name,
                      value: city.name,
                    }))
                  );

                  setSelectedCity({
                    label: selectedOption.city,
                    value: selectedOption.city,
                  });
                }
              }
            }}

            isDisabled={Boolean(emIdFromUrl || _id)} // ✅ disable if auto-selected
            value={selectedOption} // ✅ keeps it auto-selected
            placeholder="Select..."
          />
        </div>

        <div style={{ marginBottom: "0.8rem" }}>
          <label className={instiCss.instiLabel} htmlFor="country">
            Country <span style={{ color: "red" }}>*</span>
          </label>
          <input
            id="country"
            className={instiCss.instiInput}
            value={"India"}
            readOnly
          />
        </div>
        <div style={{ marginBottom: "0.8rem" }}>
          <label className={instiCss.instiLabel} htmlFor="state">
            State <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            id="state"
            options={states}
            value={selectedState}
            onChange={handleStateChange}
            isDisabled={Boolean(emIdFromUrl || _id) || Boolean(selectedOption)}

          // isDisabled={Boolean(emIdFromUrl || _id)} // ✅ Disable when EM locked
          />
        </div>
        <div style={{ marginBottom: "0.8rem" }}>
          <label className={instiCss.instiLabel} htmlFor="city">
            City <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            id="city"
            options={cities}
            value={selectedCity}
            onChange={handleCityChange}
            // isDisabled={Boolean(emIdFromUrl || _id) || Boolean(selectedOption)}

          // isDisabled={Boolean(emIdFromUrl || _id)} // ✅ Disable when EM locked

          />
        </div>



        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <button
            onClick={
              isEdit
                ? handleUpdateClick
                : async () => {
                  await handleinstiterClick();
                  onSubmit();
                }
            }
            className={instiCss.instiBtn}
            disabled={isBtnDisabled}
          >
            {isinstitering
              ? isEdit
                ? "Updating..."
                : `Adding...`
              : isEdit
                ? "Update"
                : `Add ${entityName}`}
          </button>
        </div>
      </div>
    );
  };

  return (
    // <div className={instiCss.outerDiv}>
    //     <SecCard>
    //         <BackButton text="Back to Manage Institutes" customPath="/institutes/all" />

    //         <h2 className="text-ff1">
    //             Add {activeTab === 'institute' ? 'Institute' : 'School'}
    //         </h2>

    //         {renderForm()}
    //     </SecCard>
    // </div>
    <div className={instiCss.outerDiv}>
      <SecCard>
        {/* <BackButton
          text={
            activeTab === "thalir"
              ? "Back to Manage Thalir"
              : "Back to Manage Institutes"
          }
          customPath={
            activeTab === "thalir"
              ? `/institutes/all?tab=thalir`
              : `/institutes/all?tab=institute`
          }
        /> */}
        <BackButton
          text={
            activeTab === "thalir"
              ? "Back to Manage Thalir"
              : "Back to Manage Colleges"
          }
          customPath={
            emIdFromUrl
              ? `/em/institute/all?tab=${activeTab}`  // ✅ when em_id exists in URL
              : activeTab === "thalir"
                ? `/institutes/all?tab=thalir`
                : `/institutes/all?tab=institute`
          }
        />


        <h2 className="text-ff1">
          Add {activeTab === "institute" ? "College" : "School"}
        </h2>

        {renderForm()}
      </SecCard>
    </div>
  );
};

export default Userinsti;
